<!-- <div [class.ig-border-spinner]="imgLoaded&&item.pinnedTime&&!isSimple" class="h-full"> -->
<div class="h-full">
  <div class="h-full shadow-md bg-white transition-all cursor-pointer hover:shadow-2xl relative"
    [class.ig-pinned]="item?.pinnedTime&&!isSimple" [class.full-height]="item?.socialName==='promotion'"
    (click)="showDetails()">
    <ig-image [src]="item?.cover?.source" [alt]="item?.name" cls="w-full object-cover h-[198px]"
      (onLoaded)="imgLoaded=true"></ig-image>
    <ng-container *ngIf="item?.socialName!=='promotion'">
      <div class="flex">
        <ng-container *ngIf="getItemType()==='event'">
          <ig-event-time *ngIf="!isSimple" [item]="item" mode="two-lines" class="flex-[4]"></ig-event-time>
          <div *ngIf="isSimple"
            class="root-event-btn-bg h-[64px] flex items-center flex-[4] pl-4 text-white font-semibold overflow-hidden">
            {{item?.name}}</div>
        </ng-container>
        <ng-container *ngIf="getItemType()==='place'">
          <div
            class="root-event-btn-bg h-[64px] flex items-center flex-[4] pl-4 text-white font-semibold overflow-hidden">
            {{item?.name}}</div>
        </ng-container>
        <div
          class="h-16 leading-8 bg-orange-300 text-white text-sm font-semibold text-center flex-[1] root-event-btn-bg flex justify-center items-center">
          <div
            class="rounded-full border-4 border-[hsla(0,0%,100%,.2)] text-3xl font-light w-9 h-9 flex justify-center items-center">
            <span class="relative">+</span>
          </div>
        </div>
      </div>

      <div *ngIf="!isSimple" class="bg-white p-4 h-48">
        <span *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && item?.isChoice"
          class="px-2 py-1 relative -top-1.5 mb-1 inline-block bg-gradient-to-r from-[#773bf2] to-[#b04aea] text-xs text-white">
          {{getItemType()==='event' ? editorChoiceText.editorChoiceForEvent
          : editorChoiceText.editorChoiceForPlace}}
        </span>
        <ng-container *ngIf="getItemType()==='event'">
          <div *ngIf="getItemType()==='event'" class="text-xs text-gray-800 font-semibold">HOSTED BY:
            {{item?.owner?.name}}</div>
          <div class="text-base text-gray-800 font-semibold my-2">{{item?.name}}</div>
        </ng-container>
        <ng-container *ngIf="getItemType()==='place'">
          <div class="text-base text-gray-800 my-2">{{getDisplayCategory(item)}}</div>
        </ng-container>

        <div class="text-sm text-gray-600">{{item?.address?.address}}</div>
      </div>
    </ng-container>

  </div>
</div>